module.exports = __webpack_public_path__ + "img/doener-2.cfad3fb3.jpg";